export const TOOLING_CONSTS = {
  moduleName: 'epb-tooling',

  getters: {
    state: 'state',
    pagination: 'pagination',
  },

  actions: {
    loadToolConfig: 'loadToolConfig',

    list: 'list',
    findConflictingItems: 'findConflictingItems',
    create: 'create',
    read: 'read',
    update: 'update',
    delete: 'delete',

    setPagination: 'setPagination',
    setSorting: 'setSorting',
  },

  mutations: {
    setState: 'setState',
    setPagination: 'setPagination',
  },

  storage: {
    itemsPerPage: 'rows',
  },
}
